import { useEffect } from 'react'
import { useParams, useLocation } from 'react-router-dom'
import { useContentBundle } from '@/hooks/useContentBundle'
import { useAppStore } from '@/store/appStore'

const APP_NAME = 'CMMI Model Viewer'

const OVERLAY_LABELS: Record<string, string> = {
  overview: 'Overview',
  appendices: 'Appendices',
  glossary: 'Glossary',
  'release-notes': 'Release Notes',
  'user-content': 'My Content',
  faq: 'FAQ',
  crosswalks: 'Crosswalks',
}

export function usePageTitle() {
  const { practiceAreaId, practiceId } = useParams()
  const { pathname } = useLocation()
  const { data: bundle } = useContentBundle()
  const overlayPage = useAppStore(s => s.overlayPage)

  useEffect(() => {
    let title = APP_NAME

    if (overlayPage) {
      const label = OVERLAY_LABELS[overlayPage.type]
      if (label) title = `${label} - ${APP_NAME}`
    } else if (practiceAreaId && bundle) {
      const pa = bundle.practiceAreas.find(p => p.id === Number(practiceAreaId))
      if (pa) title = `${pa.name} - ${APP_NAME}`
    } else if (practiceId && bundle) {
      const practice = bundle.practices.find(p => p.id === Number(practiceId))
      if (practice) title = `${practice.name} - ${APP_NAME}`
    } else if (pathname === '/search') {
      title = `Search - ${APP_NAME}`
    }

    document.title = title
  }, [overlayPage, practiceAreaId, practiceId, pathname, bundle])
}
